export const ADMIN_PAGE_GROUPS = [
  {
    id: 'main',
    label: 'Main',
    pages: [
      { key: 'dashboard', label: 'Dashboard', to: '/dashboard' },
    ],
  },
  {
    id: 'sales',
    label: 'Sales & Billing',
    pages: [
      { key: 'clients', label: 'Ad Clients', to: '/clients' },
      { key: 'sales', label: 'New Sale / Order', to: '/sales' },
      { key: 'invoices', label: 'Invoices', to: '/invoices' },
      { key: 'payments', label: 'Payments', to: '/payments' },
      { key: 'expenses', label: 'Expenses', to: '/expenses' },
      { key: 'billManagement', label: 'Bill Management', to: '/billManagement' },
    ],
  },
  {
    id: 'magazine',
    label: 'Magazine Portal',
    pages: [
      { key: 'magazine/issues', label: 'Manage Issues', to: '/magazine/issues' },
      { key: 'magazine/plans', label: 'Subscription Plans', to: '/magazine/plans' },
      { key: 'magazine/subscribers', label: 'Subscribers', to: '/magazine/subscribers' },
      { key: 'magazine/packing', label: 'Packing Desk', to: '/magazine/packing' },
      { key: 'magazine/newsletter', label: 'Flash Newsletter', to: '/magazine/newsletter' },
      { key: 'magazine/orders', label: 'Website Orders', to: '/magazine/orders' },
      { key: 'magazine/delivery', label: 'Delivery Reports', to: '/magazine/delivery' },
      { key: 'magazine/contact-requests', label: 'Contact Requests', to: '/magazine/contact-requests' },
      { key: 'magazine/users', label: 'Magazine Users', to: '/magazine/users' },
    ],
  },
  {
    id: 'hr',
    label: 'Human Resources',
    pages: [
      { key: 'hr/employees', label: 'Employees', to: '/hr/employees' },
      { key: 'hr/salaries', label: 'Salaries', to: '/hr/salaries' },
    ],
  },
  {
    id: 'attendance',
    label: 'Attendance',
    pages: [
      { key: 'attendance/kiosk', label: 'Live Kiosk', to: '/attendance/kiosk' },
      { key: 'attendance/report', label: 'Reports', to: '/attendance/report' },
    ],
  },
  {
    id: 'email',
    label: 'Email Center',
    pages: [
      { key: 'admin/email-center', label: 'Notifications & Templates', to: '/admin/email-center' },
      { key: 'admin/email-logs', label: 'Send History', to: '/admin/email-logs' },
    ],
  },
];

export const ALL_ASSIGNABLE_PAGE_KEYS = ADMIN_PAGE_GROUPS.flatMap((g) => g.pages.map((p) => p.key));

export function normalizePortalPath(path) {
  const raw = String(path || '');
  if (!raw) return raw;
  return raw.replace(/^\/portal_hd_99(?=\/|$)/, '/portal-hd-99');
}

export function pageKeyFromPath(to) {
  return String(to || '')
    .replace(/^\//, '')
    .replace(/^portal-hd-99\//, '')
    .replace(/^portal_hd_99\//, '');
}

export function isAdminUser(user) {
  if (!user) return false;
  if (String(user.role || '').toLowerCase() === 'admin') return true;
  return Number(user.is_admin) === 1;
}

export function normalizeAllowedPages(user) {
  const raw = user?.allowed_pages;
  if (!Array.isArray(raw)) return [];
  return raw.map((p) => pageKeyFromPath(p)).filter(Boolean);
}

export function canAccessPage(user, to) {
  if (!user) return false;
  if (isAdminUser(user)) return true;
  const key = pageKeyFromPath(to);
  if (!key) return false;
  return normalizeAllowedPages(user).includes(key);
}

export function firstAllowedPath(user) {
  if (!user) return '/portal-hd-99/login';
  if (isAdminUser(user)) return '/dashboard';
  const first = normalizeAllowedPages(user)[0];
  if (!first) return '/no-access';
  return `/${first}`;
}

export function firstAllowedSidebarPath(user) {
  if (!user || isAdminUser(user)) return '/dashboard';
  const first = normalizeAllowedPages(user)[0];
  return first ? `/${first}` : '/no-access';
}

export function pageLabel(key) {
  for (const group of ADMIN_PAGE_GROUPS) {
    const found = group.pages.find((p) => p.key === key);
    if (found) return found.label;
  }
  return key;
}
